import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = { class: "logo-section" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "placeholder-text"
}
const _hoisted_5 = ["innerHTML"]

import { ref, watch, onMounted } from 'vue';
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

  const endpoint = process.env.VUE_APP_HYGRAPH_URL;
  const activeMenu = ref('home')

  const setActiveMenu = (menuName : string) =>{
    activeMenu.value = menuName;
    isMenuOpen.value = false;
  }
  
  const hoverItem = ref<string | null>(null);

  const getManualStyle = (name: string) => {
    const isActive = activeMenu.value === name;
    const isHovered = hoverItem.value === name;
    
    const showDestaque = isActive || isHovered;

    return {
      color: showDestaque ? headerData.value.hoverColor : headerData.value.textColor,
      borderBottom: `2px solid ${showDestaque ? headerData.value.hoverColor : 'transparent'}`,
      paddingBottom: '5px',
      transition: 'all 0.3s ease',
      fontWeight: '500',
      cursor: 'pointer'
    };
  };
  
  const headerData = ref({
    brandText: '', 
    imageUrl: '',
    bgColor: '#0E2038',
    textColor: '#ffffff',
    hoverColor: '#9ACB56'
  });

  const fetchHeaderConfig = async () => {
    try {      
      const query = `{
        headers {
          brandText
          bgColor { hex }
          textColor { hex }
          hoverColor { hex }
          image { url }
        }
      }`;

      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query })
      });
      
      const { data } = await res.json();
      if (data?.headers?.[0]) {
        const h = data.headers[0];
        // Atualizando o estado reativo
        headerData.value = {
          brandText: h.brandText || '',
          imageUrl: h.image?.url || '',
          bgColor: h.bgColor?.hex || '#0E2038',
          textColor: h.textColor?.hex || '#ffffff',
          hoverColor: h.hoverColor?.hex || '#9ACB56'
        };
      }
    } catch (error) {
      console.error("Erro ao carregar configurações:", error);
    }
  };

  // 1. Estado para controlar se o menu está aberto ou não
const isMenuOpen = ref(false);

// 2. Função para alternar o estado (abre/fecha)
const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};

  // 3. Função para fechar o menu (útil quando clicar em um link)
  const closeMenu = () => {
    isMenuOpen.value = false;
  };

  // 4. Bloqueia o scroll da página quando o menu estiver aberto
  // Isso evita que o usuário role o fundo do site enquanto navega no menu
  watch(isMenuOpen, (isOpen) => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  });


  onMounted(fetchHeaderConfig);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: "main-header",
    style: _normalizeStyle({ backgroundColor: headerData.value.bgColor, '--hover-color': headerData.value.hoverColor })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "logo-icon",
          style: _normalizeStyle({ backgroundColor: headerData.value.bgColor })
        }, [
          (headerData.value.imageUrl)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: headerData.value.imageUrl,
                class: "header-logo-img"
              }, null, 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, "FP"))
        ], 4),
        _createElementVNode("div", {
          class: "logo-text-rich",
          innerHTML: headerData.value.brandText,
          style: _normalizeStyle({ color: headerData.value.textColor })
        }, null, 12, _hoisted_5)
      ]),
      _createElementVNode("button", {
        class: "menu-toggle",
        onClick: toggleMenu,
        "aria-label": "Abrir Menu"
      }, [
        _createElementVNode("span", {
          class: _normalizeClass({ 'open': isMenuOpen.value })
        }, null, 2),
        _createElementVNode("span", {
          class: _normalizeClass({ 'open': isMenuOpen.value })
        }, null, 2),
        _createElementVNode("span", {
          class: _normalizeClass({ 'open': isMenuOpen.value })
        }, null, 2)
      ]),
      _createElementVNode("nav", {
        class: _normalizeClass(["nav-menu", { 'is-active': isMenuOpen.value }])
      }, [
        _createVNode(_component_router_link, {
          to: { path: '/', hash: '#home' },
          class: "nav-link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveMenu('home')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              style: _normalizeStyle(getManualStyle('home'))
            }, "Home", 4)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: { path: '/ebooks'},
          class: "nav-link",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveMenu('Livros')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              style: _normalizeStyle(getManualStyle('Livros'))
            }, "Livros", 4)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: { path: '/', hash: '#information' },
          class: "nav-link",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (setActiveMenu('Sobre')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              style: _normalizeStyle(getManualStyle('Sobre'))
            }, "Sobre", 4)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: { path: '/', hash: '#contato' },
          class: "nav-link",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (setActiveMenu('Contato')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              style: _normalizeStyle(getManualStyle('Contato'))
            }, "Contato", 4)
          ]),
          _: 1
        })
      ], 2)
    ])
  ], 4))
}
}

})